import { ref } from 'vue'
import { defineStore } from 'pinia'

// In-call connection health, driven by the Twilio Call events wired up in
// useCall's setupCallHandlers: 'reconnecting'/'reconnected' when media or
// signaling drops mid-call, and 'warning'/'warning-cleared' when the SDK's
// network-quality thresholds (high-rtt, high-jitter, low-mos, ...) trip.
export const useConnectionStore = defineStore('connection', () => {
  const isReconnecting = ref(false)
  const callWarnings = ref<string[]>([])

  const addWarning = (name: string) => {
    if (!callWarnings.value.includes(name)) {
      callWarnings.value.push(name)
    }
  }

  const clearWarning = (name: string) => {
    callWarnings.value = callWarnings.value.filter((warning) => warning !== name)
  }

  const resetCallHealth = () => {
    isReconnecting.value = false
    callWarnings.value = []
  }

  return { isReconnecting, callWarnings, addWarning, clearWarning, resetCallHealth }
})
